import api from './api_client';

export const applicationService = {
  createWithCV: async (formData) => {
    // formData should be a FormData object with file uploads
    // Note: Don't set Content-Type header manually - Axios will set it with correct boundary
    const response = await api.post('/recruitment/applications', formData);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await api.get('/recruitment/applications', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/recruitment/applications/${id}`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/recruitment/applications/${id}/status`, null, {
      params: { new_status: status }
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/recruitment/applications/${id}`);
    return response.data;
  }
};

export default applicationService;
